import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faChevronLeft,
  faChevronRight,
  faPerson,
  faPersonRifle,
  faD,
  faPeopleArrows,
  faPeopleLine,
  faPeopleGroup,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import Card from "./components/Card";
import { Dummy } from "../../pages/CommonPublicPages/Navbars/components/Dummy";
const Guidance = () => {
  const sliderRef = useRef(null);
  const [activeSection, setActiveSection] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('div[id^="section"]');
      let active = null;

      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const topOffset = rect.top;

        if (topOffset >= 0 && topOffset <= window.innerHeight) {
          active = section.id;
        }
      });

      setActiveSection(active);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };
  const cards = [
    {
      courceName: "Card 1",
      description: "Single short line about this course",
      duration: 75,
      totalVideos: 400,
    },
    {
      courceName: "Card 2",
      description: "Single short line about this course",
      duration: 75,
      totalVideos: 400,
    },
    {
      courceName: "Card 3",
      description: "Single short line about this course",
      duration: 75,
      totalVideos: 400,
    },
    {
      courceName: "Card 4",
      description: "Single short line about this course",
      duration: 75,
      totalVideos: 400,
    },
    {
      courceName: "Card 5",
      description: "Single short line about this course",
      duration: 75,
      totalVideos: 400,
    },
    {
      courceName: "Card 6",
      description: "Single short line about this course",
      duration: 75,
      totalVideos: 400,
    },
    {
      courceName: "Card 6",
      description: "Single short line about this course",
      duration: 75,
      totalVideos: 400,
    },
    {
      courceName: "Card 6",
      description: "Single short line about this course",
      duration: 75,
      totalVideos: 400,
    },
    {
      courceName: "Card 6",
      description: "Single short line about this course",
      duration: 75,
      totalVideos: 400,
    },
    {
      courceName: "Card 6",
      description: "Single short line about this course",
      duration: 75,
      totalVideos: 400,
    },
  ];

  return (
    <div>
        <Dummy />
      <div className="mt-16 px-28 min-h-screen">
        <div className="sticky top-0 bg-white z-50">
          <div className="flex justify-between">
            <h4 className="text-3xl font-medium">Career guidance</h4>
            <form>
              <input
                className="rounded-l-full border-gray-200"
                placeholder="Search"
                type="search"
              />
              <button className="text-white border-gray-500' bg-blue-700 border rounded-r-full p-2">
                <FontAwesomeIcon icon={faSearch} />
              </button>
            </form>
          </div>
          <div className="flex justify-between py-3">
            <div className="flex gap-5 mt-4 px-1">
              <Link
                to="/interview-question"
                className={`pb-2 ${
                  activeSection === "section1" ? "border-b-2 border-black" : ""
                }`}
              >
                Interview question & answers
              </Link>
              <Link
                to="/career-management"
                className={`pb-2 ${
                  activeSection === "section2" ? "border-b-2 border-black" : ""
                }`}
              >
                Career management
              </Link>
              <Link
                to="/learn-from-leaders"
                className={`pb-2 ${
                  activeSection === "section3" ? "border-b-2 border-black" : ""
                }`}
              >
                Learn from leaders
              </Link>
              <Link
                to="/interview-experiences"
                className={`pb-2 ${
                  activeSection === "section4" ? "border-b-2 border-black" : ""
                }`}
              >
                Interview experiences
              </Link>
            </div>
            <div className="flex ">
              <p className="my-0 pt-7">
                <FontAwesomeIcon icon={faPeopleGroup} /> Comment Count
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <div id="section1" className="mt-8 h-screen">
            <h4>HR interview question & answers</h4>
            <p>A single line about HR interview question and answer.</p>
            <div className="flex justify-between mt-4">
              <button
                onClick={scrollLeft}
                className="mr-3 hover:bg-gray-300 w-20 mt-14 h-[320px] "
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              <div
                ref={sliderRef}
                className="flex overflow-x-scroll scroll-smooth space-x-4 p-4"
                style={{ scrollSnapType: "x mandatory" }}
              >
                {cards.map((card, index) => (
                  <Card
                    key={index}
                    courseName={card.courseName}
                    description={card.description}
                    duration={card.duration}
                    totalVideos={card.totalVideos}
                  />
                ))}
              </div>
              <button
                onClick={scrollRight}
                className="ml-3 hover:bg-gray-300 mt-14 w-20 h-[330px] "
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          </div>

          <div id="section2" className=" h-screen">
            <h4>Career management</h4>
            <p>A single line about career management.</p>
            <div className="flex justify-between mt-4">
              <button
                onClick={scrollLeft}
                className="mr-3 hover:bg-gray-300 w-20 mt-14 h-[320px] "
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              <div
                ref={sliderRef}
                className="flex overflow-x-scroll scroll-smooth space-x-4 p-4"
                style={{ scrollSnapType: "x mandatory" }}
              >
                {cards.map((card, index) => (
                  <Card
                    key={index}
                    courseName={card.courseName}
                    description={card.description}
                    duration={card.duration}
                    totalVideos={card.totalVideos}
                  />
                ))}
              </div>
              <button
                onClick={scrollRight}
                className="ml-3 hover:bg-gray-300 mt-14 w-20 h-[330px] "
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          </div>

          <div id="section3" className=" h-screen">
            <h4>Learn from leaders</h4>
            <p>A single line about Learn from leaders.</p>
            <div className="flex justify-between mt-4">
              <button
                onClick={scrollLeft}
                className="mr-3 hover:bg-gray-300 w-20 mt-14 h-[320px] "
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              <div
                ref={sliderRef}
                className="flex overflow-x-scroll scroll-smooth space-x-4 p-4"
                style={{ scrollSnapType: "x mandatory" }}
              >
                {cards.map((card, index) => (
                  <Card
                    key={index}
                    courseName={card.courseName}
                    description={card.description}
                    duration={card.duration}
                    totalVideos={card.totalVideos}
                  />
                ))}
              </div>
              <button
                onClick={scrollRight}
                className="ml-3 hover:bg-gray-300 mt-14 w-20 h-[330px] "
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          </div>

          <div id="section4" className="h-screen">
            <h4>Interview experiences</h4>
            <p>A single line about Interview experiences.</p>
            <div className="flex justify-between mt-4">
              <button
                onClick={scrollLeft}
                className="mr-3 hover:bg-gray-300 w-20 mt-14 h-[320px] "
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              <div
                ref={sliderRef}
                className="flex overflow-x-scroll scroll-smooth space-x-4 p-4"
                style={{ scrollSnapType: "x mandatory" }}
              >
                {cards.map((card, index) => (
                  <Card
                    key={index}
                    courseName={card.courseName}
                    description={card.description}
                    duration={card.duration}
                    totalVideos={card.totalVideos}
                  />
                ))}
              </div>
              <button
                onClick={scrollRight}
                className="ml-3 hover:bg-gray-300 mt-14 w-20 h-[330px] "
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Guidance;
